import { NgModule } from '@angular/core';
import { CardComponent } from '../../../ui-kit/atoms/card/card.component';
import { BodyComponent } from '../../../ui-kit/atoms/body/body.component';
import { TextComponent } from '../../../ui-kit/atoms/text/text.component';
import { SkeletoonsComponent } from '../../../ui-kit/atoms/skeletoons/skeletoons.component';
import { IconComponent } from '../../../ui-kit/atoms/icon/icon.component';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { ButtonComponent } from '../../../ui-kit/atoms/button/button.component';
import { FooComponent } from '../../../ui-kit/atoms/foo/foo.component';
import { ChipComponent } from '../../../ui-kit/atoms/chip/chip.component';
import { HeadComponent } from '../../../ui-kit/atoms/head/head.component';
import { TabMenuComponent } from '../../../ui-kit/atoms/tab-menu/tab-menu.component';
import { ListItemComponent } from '../../../ui-kit/atoms/list-item/list-item.component';
import { TabViewComponent } from '../../../ui-kit/atoms/tab-view/tab-view.component';
import { BreadCrumbComponent } from '../../../ui-kit/organisms/bread-crumb/bread-crumb.component';



@NgModule({
  declarations: [],
  imports: [    
    CardComponent,
    BodyComponent,
    FooComponent,
    TextComponent,
    ButtonComponent,
    SkeletoonsComponent,
    IconComponent,
    HeadComponent,
    ChipComponent,
    TabMenuComponent,
    TabViewComponent,
    ListItemComponent,
    BreadCrumbComponent
  ],
  exports: [
    CardComponent,
    BodyComponent,
    FooComponent,
    TextComponent,
    ButtonComponent,
    SkeletoonsComponent,
    IconComponent,
    HeadComponent,
    ChipComponent,
    TabMenuComponent,
    TabViewComponent,
    ListItemComponent,
    BreadCrumbComponent
  ],
  providers: [ provideAngularSvgIcon() ],
})
export class UiKitModule { }
